import { defineStore } from "pinia";
import axios from "axios";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    mvCoins: 0,
  }),
  actions: {
    async obtenerNuevaData() {
      try {
        if (!this.user || !this.user.id) {
          console.error("Usuario no encontrado en localStorage");
          return;
        }

        const response = await axios.get(
          `https://mvexpress.mx/api/get-mvcoins/${this.user.id}`
        );

        this.user = response.data;
        this.mvCoins = parseFloat(response.data.mvCoins);

        // Mantener localStorage actualizado
        localStorage.setItem("user", JSON.stringify(this.user));
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    },
  },
});
